import dayjs from 'dayjs';
import {useEffect, useState} from 'react';
import styled from 'styled-components';
import {FULL_DATE_FORMAT} from '@/constants';
import {useGA4WithParams} from '@/hooks/tracking';
import {TOOLBOX_ANALYSIS_TYPE} from '@/map/constants';
import {ToolboxItemProps} from '../';
import {useAiPromptStack} from '../../AiPrompt/hook';
import TooltipImage from '../assets/ai-new-tooltip.png';
import {ReactComponent as MenuIcon} from '../assets/ai-prompt.svg';
import {ButtonGroup, ToolboxItem} from '../StyledComponents';

const TOOLTIP_STORAGE_KEY = 'myfc/ai-prompt-new';
const HOWTO_STORAGE_KEY = 'myfc/ai-prompt-howto';

export const AiPromptButton = (props: ToolboxItemProps) => {
  const [showNewTooltip, setNewTooltip] = useState<boolean>(false);
  const [isHighlight, setHighlight] = useState<boolean>(false);
  const {hasStack, toggleAiPrompt} = useAiPromptStack();
  const tracking = useGA4WithParams();

  const setTimestamp = (storageKey: string) => {
    localStorage.setItem(storageKey, dayjs().format(FULL_DATE_FORMAT));
  };

  const handleTooltipClick = () => {
    setNewTooltip(false);
    setTimestamp(TOOLTIP_STORAGE_KEY);
  };

  const handleClick = () => {
    toggleAiPrompt();
    tracking('AI_analysis_open', {analysis_type: TOOLBOX_ANALYSIS_TYPE});

    if (showNewTooltip) {
      handleTooltipClick();
    }

    if (isHighlight) {
      setHighlight(false);
      setTimestamp(HOWTO_STORAGE_KEY);
    }
  };

  useEffect(() => {
    const showTooltip = !localStorage.getItem(TOOLTIP_STORAGE_KEY);
    const showHighlight = !localStorage.getItem(HOWTO_STORAGE_KEY);

    if (showTooltip) {
      setNewTooltip(true);
    }

    if (showHighlight) {
      setHighlight(true);
    }
  }, []);

  return (
    <Container>
      <ToolboxItem
        {...props}
        highlight={isHighlight || hasStack}
        onClick={handleClick}
        isFirstItem
        isLastItem
      >
        <MenuIcon />
      </ToolboxItem>
      {showNewTooltip && (
        <TooltipWrapper onClick={handleTooltipClick}>
          <img
            src={TooltipImage}
            alt="AI 상권 분석 기능이 생겼어요"
            width={266}
          />
        </TooltipWrapper>
      )}
    </Container>
  );
};

const Container = styled(ButtonGroup)`
  position: relative;
`;

const TooltipWrapper = styled.div`
  position: absolute;
  left: -273px;
  top: -11px;
  cursor: pointer;
`;
